import Immutable from 'immutable';
import Image from './image';

const Coupon = Immutable.Record({
  winLimit: 0,
  statusCode: '',
  usedStartAt: 0,
  createdAt: 0,
  title: '',
  winPercent: 0.0,
  content: '',
  entryEndAt: 0,
  serialAutoFlag: false,
  winImage: new Image(),
  winImageId: 0,
  id: 0,
  winPercentCustomFlag: false,
  modifiedAt: 0,
  entryStartAt: 0,
  entryCount: 0,
  usedEndAt: 0,
  remainingWinCount: 0,
  shareFlag: false,
  entryImageId: 0,
  winCount: 0,
  entryImage: new Image(),
  creatorId: 0,
  modifierId: 0,
  onlineFlag: false,
  serialFileId: 0,
  permalink: ''
});

export const fillDetails = (coupon, entities) => {
  const entryImageId = coupon.entryImage;
  const winImageId = coupon.winImage;
  return coupon
          .update('entryImage', image => entities.getIn(['images', `${entryImageId}`]))
          .update('winImage', image => entities.getIn(['images', `${winImageId}`]));
};

export default Coupon;



// WEBPACK FOOTER //
// ./src/models/coupon.js